import React from "react";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";

const counterUpContent = [
  {
    startCount: "0",
    endCount: "915",
    endPointText: "%",
    meta: "conversation rate increase when you add true personalization to your customer experience",
    animationDelay: "0",
    bgColor: "#25E5DA",
  },
  {
    startCount: "0",
    endCount: "65",
    endPointText: "%",
    meta: "increase in revenues by optimizing your retention rate by as little as 3%",
    animationDelay: "100",
    bgColor: "#FF36AF",
  },
  {
    startCount: "0",
    endCount: "50",
    endPointText: "%",
    meta: "probability of selling to a returning customer compared to 10% when selling to a new customer",
    animationDelay: "200",
    bgColor: "#FFB13A",
  },
  {
    startCount: "0",
    endCount: "31",
    endPointText: "%",
    meta: "more spend per retained customer, they are also twice as likely to try new products when compared to new customers",
    animationDelay: "200",
    bgColor: "#FFB13A",
  },
  {
    startCount: "0",
    endCount: "25",
    endPointText: " times",
    meta: " more costly to acquire a new customer than to retain an existing one",
    animationDelay: "200",
    bgColor: "#FFB13A",
  },
];

const RetentionStatts = () => {
  const [focus, setFocus] = React.useState(false);
  return (
    <div className="row justify-content-center">
      {counterUpContent.map((val, i) => (
        <div
          className="col-lg-4 "
          data-aos="fade-up"
          data-aos-duration="600"
          data-aos-delay={val.animationDelay}
          key={i}
        >
          <div className="counter-box-five text-center mb-65">
            <div className="dot" style={{ background: val.bgColor }}></div>
            <h2 className="number font-source-code-pro">
              <span className="timer">
                {" "}
                <CountUp
                  start={focus ? val.startCount : null}
                  end={val.endCount}
                  duration={1}
                  redraw={true}
                >
                  {({ countUpRef }) => (
                    <VisibilitySensor
                      onChange={(isVisible) => {
                        if (isVisible) {
                          setFocus(true);
                        }
                      }}
                    >
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
              </span>
              {val.endPointText}
            </h2>
            <p>{val.meta}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RetentionStatts;
